import { render, staticRenderFns } from "./ZiXuanAdd.vue?vue&type=template&id=21e59696&scoped=true&"
import script from "./ZiXuanAdd.vue?vue&type=script&lang=js&"
export * from "./ZiXuanAdd.vue?vue&type=script&lang=js&"
import style0 from "./ZiXuanAdd.vue?vue&type=style&index=0&id=21e59696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e59696",
  null
  
)

export default component.exports